// Users
export const CACHE_USER = 'CACHE_USER'
export const UPDATE_BEGIN = 'UPDATE_BEGIN'
export const UPDATE_CLEAR = 'UPDATE_CLEAR'
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS'
export const UPDATE_FAILURE = 'UPDATE_FAILURE'
export const ACCOUNT_CLEAR = 'ACCOUNT_CLEAR'
export const SESSION_EXPIRE = 'SESSION_EXPIRE'
export const GET_DETAILS_SUCCESS = 'GET_DETAILS_SUCCESS'
export const GET_DETAILS_FAILURE = 'GET_DETAILS_FAILURE'

// // Users --Invoices
// export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS'
// export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE'
// export const GET_INVOICES_BEGIN = 'GET_INVOICES_BEGIN'

// Users --Delete
export const DELETION_SUCCESS = 'DELETION_SUCCESS'
export const DELETION_FAILURE = 'DELETION_FAILURE'
export const DELETION_BEGIN = 'DELETION_BEGIN'
export const DELETION_CLEAR = 'DELETION_CLEAR'

// Auth
export const LOGIN_BEGIN = 'LOGIN_BEGIN'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const SET_TOKEN = 'SET_TOKEN'

// Password
export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN'
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR'
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE'
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS'
export const PASSWORD_CHANGE_BEGIN = 'PASSWORD_CHANGE_BEGIN'
export const PASSWORD_CHANGE_CLEAR = 'PASSWORD_CHANGE_CLEAR'
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE'
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS'
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN'
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR'
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'

// Signup
export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN'
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR'
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE'
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS'
export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN'
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR'
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE'
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS'

// Subscriptions
export const SUBSCRIPTION_CHOOSE = 'SUBSCRIPTION_CHOOSE'
export const SUBSCRIPTION_CLEAR = 'SUBSCRIPTION_CLEAR'
// export const SUBSCRIPTION_BEGIN = 'SUBSCRIPTION_BEGIN'
// export const SUBSCRIPTION_SUCCESS = 'SUBSCRIPTION_SUCCESS'
// export const SUBSCRIPTION_FAILURE = 'SUBSCRIPTION_FAILURE'
// export const SUBSCRIPTION_CANCEL_BEGIN = 'SUBSCRIPTION_CANCEL_BEGIN'
// export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS'
// export const SUBSCRIPTION_CANCEL_FAILURE = 'SUBSCRIPTION_CANCEL_FAILURE'

// Plans
export const GET_PLANS_SUCCESS = 'GET_PLANS_SUCCESS'
export const GET_PLANS_FAILURE = 'GET_PLANS_FAILURE'

// Plans --Feature Limits
export const GET_PLAN_LIMITS_BEGIN = 'GET_PLAN_LIMITS_BEGIN'
export const GET_PLAN_LIMITS_SUCCESS = 'GET_PLAN_LIMITS_SUCCESS'
export const GET_PLAN_LIMITS_FAILURE = 'GET_PLAN_LIMITS_FAILURE'

// Editor
export const SET_VISIBLE_MENU = 'SET_VISIBLE_MENU'

// Campaign
export const SET_TARGET_CAMPAIGN = 'SET_TARGET_CAMPAIGN'
export const CAMPAIGN_CREATE_BEGIN = 'CAMPAIGN_CREATE_BEGIN'
export const CAMPAIGN_CREATE_FAILURE = 'CAMPAIGN_CREATE_FAILURE'
export const CAMPAIGN_CREATE_SUCCESS = 'CAMPAIGN_CREATE_SUCCESS'
export const CAMPAIGN_FETCH_SUCCESS = 'CAMPAIGN_FETCH_SUCCESS'
export const CAMPAIGNS_FETCH_SUCCESS = 'CAMPAIGNS_FETCH_SUCCESS'
export const CAMPAIGNS_FETCH_FAILURE = 'CAMPAIGNS_FETCH_FAILURE'
export const CAMPAIGN_DELETE_SUCCESS = 'CAMPAIGN_DELETE_SUCCESS'
export const CAMPAIGN_PARTIAL_SAVE_BEGIN = 'CAMPAIGN_PARTIAL_SAVE_BEGIN'
export const CAMPAIGN_PARTIAL_SAVE_SUCCESS = 'CAMPAIGN_PARTIAL_SAVE_SUCCESS'
export const CAMPAIGN_PARTIAL_SAVE_FAILURE = 'CAMPAIGN_PARTIAL_SAVE_FAILURE'
export const CAMPAIGN_CLEAR = 'CAMPAIGN_CLEAR'

// --Embed Code
export const EMBED_CODE_CHECK_BEGIN = 'EMBED_CODE_CHECK_BEGIN'
export const EMBED_CODE_CHECK_SUCCESS = 'EMBED_CODE_CHECK_SUCCESS'
export const EMBED_CODE_CHECK_FAILURE = 'EMBED_CODE_CHECK_FAILURE'
export const EMBED_CODE_CHECK_CLEAR = 'EMBED_CODE_CHECK_CLEAR'

// Domain Management
export const DOMAIN_LIST_BEGIN = 'DOMAIN_LIST_BEGIN'
export const DOMAIN_LIST_SUCCESS = 'DOMAIN_LIST_SUCCESS'
export const DOMAIN_LIST_FAILURE = 'DOMAIN_LIST_FAILURE'
export const DOMAIN_CREATE_BEGIN = 'DOMAIN_CREATE_BEGIN'
export const DOMAIN_CREATE_SUCCESS = 'DOMAIN_CREATE_SUCCESS'
export const DOMAIN_CREATE_FAILURE = 'DOMAIN_CREATE_FAILURE'
export const DOMAIN_UPDATE_BEGIN = 'DOMAIN_UPDATE_BEGIN'
export const DOMAIN_UPDATE_SUCCESS = 'DOMAIN_UPDATE_SUCCESS'
export const DOMAIN_UPDATE_FAILURE = 'DOMAIN_UPDATE_FAILURE'
export const DOMAIN_DELETE_BEGIN = 'DOMAIN_DELETE_BEGIN'
export const DOMAIN_DELETE_SUCCESS = 'DOMAIN_DELETE_SUCCESS'
export const DOMAIN_DELETE_FAILURE = 'DOMAIN_DELETE_FAILURE'
export const DOMAIN_CLEAR = 'DOMAIN_CLEAR'

// Integration Management
export const INTEGRATION_LIST_BEGIN = 'INTEGRATION_LIST_BEGIN'
export const INTEGRATION_LIST_SUCCESS = 'INTEGRATION_LIST_SUCCESS'
export const INTEGRATION_LIST_FAILURE = 'INTEGRATION_LIST_FAILURE'
export const INTEGRATION_CREATE_BEGIN = 'INTEGRATION_CREATE_BEGIN'
export const INTEGRATION_CREATE_SUCCESS = 'INTEGRATION_CREATE_SUCCESS'
export const INTEGRATION_CREATE_FAILURE = 'INTEGRATION_CREATE_FAILURE'
export const INTEGRATION_UPDATE_BEGIN = 'INTEGRATION_UPDATE_BEGIN'
export const INTEGRATION_UPDATE_SUCCESS = 'INTEGRATION_UPDATE_SUCCESS'
export const INTEGRATION_UPDATE_FAILURE = 'INTEGRATION_UPDATE_FAILURE'
export const INTEGRATION_DELETE_BEGIN = 'INTEGRATION_DELETE_BEGIN'
export const INTEGRATION_DELETE_SUCCESS = 'INTEGRATION_DELETE_SUCCESS'
export const INTEGRATION_DELETE_FAILURE = 'INTEGRATION_DELETE_FAILURE'
export const SET_TARGET_INTEGRATION = 'SET_TARGET_INTEGRATION'
export const INTEGRATION_CLEAR = 'INTEGRATION_CLEAR'

// --Widget
export const SET_TARGET_WIDGET = 'SET_TARGET_WIDGET'
export const SET_WIDGET = 'SET_WIDGET'
export const CLONE_WIDGET = 'CLONE_WIDGET'
export const DELETE_WIDGET = 'DELETE_WIDGET'

export const WIDGETS_CLEAR = 'WIDGETS_CLEAR'

export const UPDATE_WIDGET_STYLING = 'UPDATE_WIDGET_STYLING'
export const UPDATE_WIDGET_SETTINGS = 'UPDATE_WIDGET_SETTINGS'
export const UPDATE_WIDGET_DETAILS = 'UPDATE_WIDGET_DETAILS'
export const UPDATE_WIDGET_THEME = 'UPDATE_WIDGET_THEME'
export const UPDATE_ALL_WIDGETS_SETTINGS = 'UPDATE_ALL_WIDGETS_SETTINGS'

// --Step Item
export const STEP_CLEAR = 'STEP_CLEAR'

export const UPDATE_STEP_ITEMS_LIST = 'UPDATE_STEP_ITEMS_LIST'
export const SET_TARGET_STEP = 'SET_TARGET_STEP'
export const ADD_STEP = 'ADD_STEP'
export const CLONE_STEP = 'CLONE_STEP'
export const DELETE_STEP = 'DELETE_STEP'

// --Content Item
export const SET_TARGET_CONTENT_ITEM = 'SET_TARGET_CONTENT_ITEM'
export const CLEAR_TARGET_CONTENT_ITEM = 'CLEAR_TARGET_CONTENT_ITEM'
export const ADD_CONTENT_ITEM = 'ADD_CONTENT_ITEM'
export const CLONE_CONTENT_ITEM = 'CLONE_CONTENT_ITEM'
export const DELETE_CONTENT_ITEM = 'DELETE_CONTENT_ITEM'
export const UPDATE_CONTENT_ITEMS_LIST = 'UPDATE_CONTENT_ITEMS_LIST'
export const REMOVE_CONTENT_ITEM_THEME_LINK = 'REMOVE_CONTENT_ITEM_THEME_LINK'
export const UPDATE_CONTENT_ITEM = 'UPDATE_CONTENT_ITEM'
export const UPDATE_GLOBAL_CONTENT_ITEM = 'UPDATE_GLOBAL_CONTENT_ITEM'

export const CONTENT_ITEM_CLEAR = 'CONTENT_ITEM_CLEAR'

// --Analytics
export const GET_STATS_BEGIN = 'GET_STATS_BEGIN'
export const GET_STATS_SUCCESS = 'GET_STATS_SUCCESS'
export const GET_STATS_FAILURE = 'GET_STATS_FAILURE'
export const SET_STATS_TIME_FRAME = 'SET_STATS_TIME_FRAME'
export const STATS_CLEAR = 'STATS_CLEAR'

export const GET_RESPONSES_BEGIN = 'GET_RESPONSES_BEGIN'
export const GET_RESPONSES_SUCCESS = 'GET_RESPONSES_SUCCESS'
export const GET_RESPONSES_FAILURE = 'GET_RESPONSES_FAILURE'
export const RESPONSES_CLEAR = 'RESPONSES_CLEAR'
export const SET_QUERY_VALUES = 'SET_QUERY_VALUES'

export const DOWNLOAD_STATS_BEGIN = 'DOWNLOAD_STATS_BEGIN'
export const DOWNLOAD_STATS_SUCCESS = 'DOWNLOAD_STATS_SUCCESS'
export const DOWNLOAD_STATS_FAILURE = 'DOWNLOAD_STATS_FAILURE'
export const DOWNLOAD_STATS_CLEAR = 'DOWNLOAD_STATS_CLEAR'
